module.exports = __webpack_public_path__ + "img/home_icon_technicaldepartment@2x.0f962f0f.png";